// tslint:disable
/**
 * Climate Compass API
 * This document decribes the REST API that manages Climate Compass functionality. It allows user to administrate emission coefficients and emission coefficients version...  The endpoints are checked for suitable inputs like valid and not already used emission coefficients and emission coefficients versions and provided with suitable error messages depending on the operation.  # Error Responses All error reponses will contain the same fields. One of those fields is called \"errorCode\". This will contain a unique identifier of the error category. ## Generic web-server error responses All listed end-points can return generic web-server errorCodes, that are not registered for the specific end-points. These errorCodes fall into the 2 categories: 400 Climate Compass errors and 500 errors. Please refer to standard HTTP status code documentation for a full overview. Some examples of generic errorCodes, not defined on each end-point but still possible to get are:  ### Climate Compass error responses * `BAD_REQUEST` (400) * `UNAUTHORIZED` (401) * `FORBIDDEN` (403) * `NOT_FOUND` (404) * `REQUEST_TIMEOUT` (408) * `UNSUPPORTED_MEDIA_TYPE` (415)  ### Server error responses * `INTERNAL_SERVER_ERROR` (500) * `SERVICE_UNAVAILABLE` (503) * `HTTP_VERSION_NET_SUPPORTED` (505)  ## Application specific error codes Each endpoint may result in an application specific errorCode. Most of those errorCodes are related to an http status code of type BAD_REQUEST but are not limited to that http status code. For each errorCode a message will also be present. The message template for each application specific errorCode is listed here to avoid repeating it for each endpoint (responses section).  * `INTERNAL_ERROR` Internal server error. Check the internal logs for logToken with id: \'%s\'.  * `VERSION_NOT_FOUND` Version deosn\'t exist.  * `EMISSION_COEFFICIENT_NOT_FOUND` Emission Coefficient not found.  * `CALCULATION_NOT_FOUND` Calculation not found.  * `FILE_NOT_READABLE` File not readeble  * `FILE_NOT_FOUND` File not found  * `ALLOWED_NUMBER_FILES_EXCEEDED` Allowed number of files exceeded  * `ELEMENT_ALREADY_EXIST` cannot create as element already exist  * `ITEM_NOT_FOUND` the request item does not exist 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from "./configuration";
// Some imports not used depending on template conditions
// @ts-ignore
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';

export const BASE_PATH = "/klimakompasset".replace(/\/+$/, "");

/**
 *
 * @export
 */
export const COLLECTION_FORMATS = {
    csv: ",",
    ssv: " ",
    tsv: "\t",
    pipes: "|",
};

/**
 *
 * @export
 * @interface RequestArgs
 */
export interface RequestArgs {
    url: string;
    options: any;
}

/**
 *
 * @export
 * @class BaseAPI
 */
export class BaseAPI {
    protected configuration: Configuration | undefined;

    constructor(configuration?: Configuration, protected basePath: string = BASE_PATH, protected axios: AxiosInstance = globalAxios) {
        if (configuration) {
            this.configuration = configuration;
            this.basePath = configuration.basePath || this.basePath;
        }
    }
};

/**
 *
 * @export
 * @class RequiredError
 * @extends {Error}
 */
export class RequiredError extends Error {
    name: "RequiredError" = "RequiredError";
    constructor(public field: string, msg?: string) {
        super(msg);
    }
}
